export default {
    comment: 'Comments',

    delivery: {
        address: {
            placeholder: 'Enter the index',
            noIndex: 'No index',
            pvz: 'PVZ',
            city: 'City',
            street: 'Street',
            house: 'House',
            housing: 'Housing',
            building: 'Building',
            apartment: 'Apartment',
            kladr: 'Kladr',
            fias: 'FIAS',
            postcode: 'Postcode',
        },
        main: {
            title: 'Delivery',
            printTorg: 'Print TORG-12',
            printTag: 'Label Printing',
            pvz: 'PVZ',
            address: 'Delivery address',
        },
        courier: {
            courier: 'Courier',
            name: 'Courier\'s name',
            phone: 'Courier\'s phone number',
        },
        intake: {
            status: 'Status',
            id: 'ID',
            dateCreate: 'Date',
        },
    },

    fields: {
        paymentDate: 'Payment receipt date',
        planDate: 'Planned date',
    },

    order: {
        acceptance: 'Unable to get APP',
        main: {
            title: 'Basic information',
            message: 'Do you really want to change the payment method?',
        },
        status: {
            auto: 'Automatically after expiration',
            customer: 'Cancelled by the buyer',
            waiting: 'Waiting',
        },
        user: {
            'true': 'Authorized',
            'false': 'Not authorized',
        },
    },

    fieldsView: {
        id: 'Order №',
        orderSourceTypeId: 'Order source',
        orderStatusId: 'Processing status',
        partnerOrderId: 'Partner\'s order number',
        commentClient: 'Client',
        orderCommentWorker: 'Store employee',
        deliveryComment: 'For the delivery service',
        reasonCancel: 'Reason for cancellation',
        customerRequests: 'Coordination of changes with the client',
        promoCode: 'Promo code',
        commentToCustomer: 'Comment to the client',
        name: 'Client\'s name',
        userAuthorization: 'User status',
        phone: 'Customer\'s contact phone number',
        email: 'Customer\'s contact email',
        fullNameReciever: 'Recipient\'s full name',
        phoneReciever: 'Recipient\'s phone number',
        payTypeId: 'Payment method',
        payStatusId: 'Payment status',
        planDateIssued: 'Planned pickup date',
        waitReason: 'Reason for waiting',
        pfm: 'Store number',
        deliveryServiceId: 'Delivery method',
        clientSurname: 'Surname',
        clientName: 'Name',
        clientPatronymic: 'Middle name',
        deliveryClientPhone: 'Telephone',
        acceptanceActNumber: 'APP Number',
        deliveryStatusId: 'Delivery Status',
        desiredDate: 'Desired delivery date to the buyer',
        deliveryIndex: 'Delivery address',
        isTest: 'Test',
        loyaltyCardNumber: 'Loyalty Card',
        receiveStatusId: 'Payment receipt status',
        confirmationCode: 'Code verification status',
        document: 'Documents',
        paymentNumber: 'Payment number',
        paymentDate: 'Payment receipt date',
        languageId: 'Message language',
        refundReason: 'Reason for return',
        refundType: 'Refund method',
        checkingAccount: 'Payment account',
        bankName: 'Name of the bank',
        bik: 'BIK',
        correspondentAccount: 'Correspondent account',
        countCall: 'Number of dialer',
        productsForAdults: 'There are products 18+',
        deliveryServiceTypeId: 'Type of delivery',
        deliveryTrack: 'Track number',
        intake: 'Intake',
    },
};
